module.exports = __webpack_public_path__ + "static/media/organization.16e21f58.png";